import { useContext, useEffect } from 'react';
import useWidgetContext from './useWidgetContext';
import { useRouteMatch } from 'react-router';
import RouterExtensionContext from './RouterExtensionContext';
import scrollInView, { ScrollInViewType } from '../service/scrollInView';

export default function useScrollToWidgetTop(): void {
  const { currentPath, setCurrentPath } = useContext(RouterExtensionContext);
  const { configuration } = useWidgetContext();
  const data = useRouteMatch();

  useEffect(() => {
    if (data.path !== currentPath) {
      if (null !== currentPath) {
        const container = document.getElementById(configuration.containerId);

        if (!scrollInView.isInView(container, ScrollInViewType.TOP)) {
          scrollInView.scrollInView(container, ScrollInViewType.TOP);
        }
      }

      setCurrentPath(data.path);
    }
  }, [data.path]);
}
